import React, { useState } from "react";
import { useFormik } from "formik";
import "bootstrap/dist/css/bootstrap.min.css";
import Sidebar from "../../common/Sidebar";
import axios from "axios";
import { thumbGenerator } from "../../validations";

const GenerateThumb = () => {
  const [originalImages, setOriginalImages] = useState([]);
  const [generatedImages, setGeneratedImages] = useState([]);
  const [showJson, setShowJson] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);

  const formik = useFormik({
    initialValues: {
      path: "",
      selectedFiles: [],
    },
    validationSchema: thumbGenerator,
    onSubmit: async (values) => {
        await generateThumbs(values);
      
    },
  });

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      formik.setFieldValue("selectedFiles", files);
      const previews = files.map((file) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (event) => resolve(event.target.result);
          reader.readAsDataURL(file);
        });
      });
      Promise.all(previews).then((images) => setOriginalImages(images));
    }
  };

  const generateThumbs = async (values) => {
    const formData = new FormData();
    formData.append("path", values.path);
    values.selectedFiles.forEach((file) => {
      formData.append("images", file);
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_LOCAL}/api/compress/create`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.data) {
        setGeneratedImages(response.data?.data);
        setApiResponse(response.data);
      } else {
        console.warn("API returned an unexpected response:", response.data);
      }
    } catch (error) {
      console.error("Error uploading images:", error.response ? error.response.data : error.message);
      alert("Failed to upload images. Check console for details.");
    }
  };

  return (
    <div className="container mt-5">
      <Sidebar />
      <div className="card shadow-lg p-4 rounded border-0" style={{ background: "#f8f9fa" }}>
        <h3 className="text-center mb-4 text-primary">Image Compressor</h3>

        <form onSubmit={formik.handleSubmit} encType="multipart/form-data">
          <div className="mb-3">
            <label className="form-label">Upload Images</label>
            <input type="file" className="form-control" accept="image/*" multiple onChange={handleImageChange} />
            {formik.touched.selectedFiles && formik.errors.selectedFiles ? (
              <div style={{ color: "red" }}>{formik.errors.selectedFiles}</div>
            ) : null}
          </div>

          {originalImages.length > 0 && (
            <div className="mb-3">
              <h5>Original Images</h5>
              <div className="d-flex flex-wrap">
                {originalImages.map((img, index) => (
                  <img key={index} src={img} alt={`Original ${index}`} className="img-thumbnail m-2" style={{ maxWidth: "150px" }} />
                ))}
              </div>
            </div>
          )}

          <div className="mb-3">
            <label className="form-label">Select Path</label>
            <select className="form-select" name="path" onChange={formik.handleChange} value={formik.values.path}>
              <option value="" disabled>Select Path</option>
              <option value="thumbs/inspirations">Inspiration</option>
              <option value="thumbs/styles">Style</option>
              <option value="thumbs/tattoos">Tattoos</option>
            </select>
            {formik.touched.path && formik.errors.path ? (
              <div style={{ color: "red" }}>{formik.errors.path}</div>
            ) : null}
          </div>

          <button type="submit" className="btn btn-primary w-100">Compress Images</button>
        </form>

        {generatedImages?.length > 0 && (
          <div className="text-center mt-3">
            <h5>Compressed Images</h5>
            <div className="d-flex flex-wrap justify-content-center">
              {generatedImages?.map((img, index) => {
                const cleanedUrl = img?.thumb?.replace(/['"]+/g, "");
                return (
                  <div key={index} className="m-2">
                    <img src={cleanedUrl} alt={`Compressed ${index}`} className="img-thumbnail" style={{ maxWidth: "150px" }} />
                    {/* <div>
                      <a href={cleanedUrl} download={`compressed_image_${index}`} className="btn btn-success mt-2">Download</a>
                    </div> */}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {apiResponse && (
          <div className="mt-4">
            <button className="btn btn-secondary w-100" onClick={() => setShowJson(!showJson)}>
              {showJson ? "Hide JSON Response" : "Show JSON Response"}
            </button>
            {showJson && (
              <pre className="bg-light p-3 mt-3 border rounded" style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                {JSON.stringify(apiResponse, null, 2).split(/(https?:\/\/[^\s]+)/g).map((part, index) =>
                  part.match(/https?:\/\//) ? (
                    <a key={index} href={part.split('"')[0]} target="_blank" rel="noopener noreferrer">
                      {part}
                    </a>
                  ) : (
                    part
                  )
                )}
              </pre>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GenerateThumb;
